import CustomerDataContextProvider from "../context/CustomerDataContext";
import ThemeContextProvider from "../context/ThemeContext";
import CustomerDataCore from "./CustomerDataCore";

export default function CustomerData() {
    return (
        <ThemeContextProvider>
                <CustomerDataContextProvider>
                    <CustomerDataCore />
                </CustomerDataContextProvider>
        </ThemeContextProvider>
    )
}
